var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarHalfFilled = function SvgStarHalfFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00534A",
    d: "M11.999 21c-.215 0-.428-.078-.602-.177C7.318 17.893 2.156 13.03 2 7.66v-.043C2 5.067 4.326 3 7.196 3c2.181 0 4.048 1.194 4.817 2.883C12.789 4.2 14.633 3 16.802 3 19.67 3 21.998 5.068 22 7.617c-.035 1.773-.934 7.14-9.337 13.175a1.2 1.2 0 0 1-.665.208",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00534A",
    d: "M11.999 21c-.215 0-.428-.078-.602-.177C7.318 17.893 2.156 13.03 2 7.66v-.043C2 5.067 4.326 3 7.196 3c2.181 0 4.048 1.194 4.817 2.883C12 7 12 8 12 8c0 2-.002.95 0 3.5 0 0 0 6.5-.002 9.5"
  })));
};
export default SvgStarHalfFilled;